var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"detail-table"},[_c('tbody',_vm._l((_vm.rows),function(row){return _c('tr',{key:row.key},[_c('td',[_vm._v(_vm._s(row.label))]),_c('td',{staticClass:"detail-table__value",class:{ 'detail-table__value--muted': _vm.isMutedValue }},[_vm._v(_vm._s(row.value))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }